import { Link } from "react-router-dom";
import { Users, ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n";

export const RoomCard = ({ room, tall = false }) => {
  const { l, t } = useLang();
  return (
    <Link
      to={l(`/camere/${room.slug}`)}
      data-testid={`room-card-${room.slug}`}
      className="group block img-frame bg-card transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_50px_-24px_rgba(26,26,26,0.35)]"
    >
      <div className={`overflow-hidden ${tall ? "aspect-[3/4]" : "aspect-[4/3]"}`}>
        <img
          src={room.image}
          alt={room.imageAlt}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
      </div>
      <div className="p-6 md:p-7">
        <div className="flex items-center justify-between gap-3">
          <p className="text-xs uppercase tracking-[0.2em] text-terra">{room.type}</p>
          <span className="inline-flex items-center gap-1.5 text-xs text-body">
            <Users className="w-3.5 h-3.5" /> {t.roomCard.max} {room.capacity}
          </span>
        </div>
        <h3 className="font-serif text-2xl mt-3 text-ink group-hover:text-sage transition-colors duration-300">
          {room.name}
        </h3>
        <p className="mt-2 text-sm text-body leading-relaxed line-clamp-2">{room.excerpt}</p>
        <p className="mt-4 inline-flex items-center gap-1.5 text-[13px] font-semibold text-sage">
          {t.roomCard.discover}
          <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </p>
      </div>
    </Link>
  );
};
